import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from './pages/EditPage.tsx';
import {useVerifiedPermissions} from '../../hooks/useVerifiedPermissions.ts';


export const ExecutionsLayout = () => {

    const {allowedActions} = useVerifiedPermissions();

    return (
        <Routes>
            <Route
                path={'/'}
                element={
                    allowedActions.includes('ListExecutions') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to={'/'}/>
                    )
                }
            />
            <Route
                path={':id'}
                element={
                    allowedActions.includes('ViewExecution') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to={'/executions'}/>
                    )
                }
            />
        </Routes>
    );
};
